<template>
    <div>
        <p>Mise à jour des produits</p>
        <el-button type="primary" icon="fas fa-sync" @click="syncCatalogueEdox" circle></el-button>
    </div>
</template>

<script>
import script from "../../../script/script_edox.js"
export default {
  created () {
  },
  methods: {
    syncCatalogueEdox: script.syncCatalogueEdox,
  },
  watch: {
  },
  data () {
    return {
    }
  },

}
</script>

<style>

</style>